import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {EditMultiplePortfoliosDialogComponent} from "@irb/irb-clients/edit-multiple-portfolios-dialog/edit-multiple-portfolios-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class EditMultiplePortfoliosAutomationDialogGridLayoutService implements GridLayoutService<EditMultiplePortfoliosDialogComponent> {
    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Portfolio',
            field: 'portfolioName',
            width: 500,
            sort: 'asc'
        },
        {
            headerName: 'Total Accounts',
            field: 'acctQty',
            maxWidth: 150,
            width: 150
        }];
    }
}
